module.exports = __webpack_public_path__ + "media/images/salespartner/salespartner-mv-b6ff9104030764f3271c3f12b6880aba.png";